<template>
	<div class="con-1334 navBtn">
		<a v-if="prevLink" class="navBtn-prev" @click="$emit('prev', $event)">{{ prevText }}</a>
		<LoadingButton
			:text="nextText"
			class="navBtn-next btn btn-blue"
			@click="handleNext"
			:disabled="disabled"
			:loading="loading"
		/>
	</div>
</template>

<script>
import { mapMutations } from 'vuex';
import { clearBodyLocks } from 'tua-body-scroll-lock';
import LoadingButton from '@/components/elements/LoadingButton';

export default {
	components: {
		LoadingButton,
	},
	props: {
		nextLink: { type: String, default: null },
		prevLink: { type: String, default: null },
		nextText: { type: String, default: 'Tovább' },
		prevText: { type: String, default: 'Vissza' },
		disabled: { type: Boolean, default: false },
		popup: { type: [String, Array], default: null },
		showPopup: { type: Boolean, default: false },
		loading: { type: Boolean, default: false },
	},
	methods: {
		...mapMutations({ setPopup: 'showPopup' }),
		handleNext(e) {
			if (this.showPopup) {
				this.setPopup(this.popup);
			} else {
				clearBodyLocks();
				this.$emit('next', e);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.lds-ring {
	display: inline-block;
	position: absolute;
	width: 24px;
	height: 24px;
}
.lds-ring div {
	box-sizing: border-box;
	display: block;
	position: absolute;
	width: 24px;
	height: 24px;
	border: 2px solid #fff;
	border-radius: 50%;
	animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
	border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
	animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
	animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
	animation-delay: -0.15s;
}
@keyframes lds-ring {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
</style>
